<template>
  <div v-if="test._id">
    <check-password v-if="states[mode] === 'CHECKPASSWORD'" @success-password="onChangeMode"/>
    <test-agreement v-else-if="states[mode] === 'AGREEMENT'" @success-agreement="onChangeMode"/>
    <div v-else-if="states[mode] === 'TEST'">
      <div class="clearfix mt-3 mb-5">
        <div class="float-left page-title"><mdb-icon icon="chalkboard-teacher" /> {{this.test.name}} </div>
        <div class="float-right"><mdb-btn class="p-2" icon="check" @click="onSaveTest()"  :disabled="!isOk"> 제출</mdb-btn></div>
      </div>
      <div>
        <div v-for="(t, tx) in test.test" :key="t._id" class="mb-3">
          <div class="sub-title my-3 underline"><mdb-icon icon="chalkboard" /> {{t.unitName}}</div>
          <div v-for="(q, qx) in t.questions" :key="q._id" class="mb-3">
            <question :question="q" :num="qx+1" v-model="answer.testAnswers[tx].answers[qx].answer"/>
          </div>
        </div>
      </div>
      <div class="text-right"><mdb-btn class="p-2" icon="check" @click="onSaveTest()" :disabled="!isOk"> 제출</mdb-btn></div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import FolderLabel from '@/components/common/FolderLabel.vue'
import TestStatus from '@/components/test/TestStatus.vue';
import Question from '@/components/test/Question.vue';
import CheckPassword from '@/components/test/CheckPassword.vue';
import TestAgreement from '@/components/test/TestAgreement.vue';

export default {
  components: { Question, CheckPassword, TestAgreement },
  name: 'StudentWritingTestExam',
  props: [],
  data: () => ({
    mode: 0,
    states: ['CHECKPASSWORD', 'AGREEMENT', 'TEST'],
    test: {},
    answer: {}
  }),
  computed: {
    ...mapState('auth', ['profile']),
    ...mapGetters('training', ['teacher']),
    isOk () {
      if (!this.answer.testAnswers) return false
      for (let tx = 0; tx < this.answer.testAnswers.length; tx++) {
        for (let qx = 0; qx < this.answer.testAnswers[tx].answers.length; qx++) {
          if (!this.answer.testAnswers[tx].answers[qx].answer) return false
        }
      }
      return true
    }
  },
  methods: {
    async onSaveTest () {
      if (!confirm('제출할까요?')) return
      this.answer.mark(this.test.test, this.teacher)
      this.answer = await this.answer.save()
      this.$router.push({
        name: 'StudentWritingTestView',
        query: { test: this.test._id, answer: this.answer._id }
      })
    },
    onChangeMode () {
      this.mode++;
    }
  },
  async created () {
    const { test } = this.$route.query
    this.test = await this.$WritingTest.get(test);
    const { training, name, code, seq } = this.test
    this.answer = this.$WritingTestAnswer.create(training, this.profile._id, this.test, name, code, seq)
  }
}
</script>
